import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { WrxOptionSlice } from './types';
import { getWrxOptions} from '../../api/wrxOption';


const initialState: WrxOptionSlice[] = [];

export const wrxOptionSlice = createSlice({
  name: 'wrxOptions',
  initialState,
  reducers: {
    loadWrxOptions: (state, action: PayloadAction<WrxOptionSlice[]>) => {
      return action.payload;
    },
    getWrxOptionsFailed: (state, action: PayloadAction<WrxOptionSlice>) => {
    }
  },
});
export const { loadWrxOptions } = wrxOptionSlice.actions;


export const fetchWrxOptions = (): AppThunk => async (dispatch, getState) => {
    const { wrxOptions, user } = getState();   
    
    try {
        const wrx_options = await getWrxOptions(user.api_key)
        const refinedWrxOptions: WrxOptionSlice[] = prepareWrxOptionsForStore(wrx_options);
        
        dispatch(loadWrxOptions(refinedWrxOptions));
      } catch (err) {
        console.error(err.toString())
      }
}

export const prepareWrxOptionsForStore = (wrx_options) => {
    return wrx_options.data.map((wrx_option, index) => {
        return {
            id: index,
            wrx_option_id: wrx_option.id,
            description: wrx_option.description,        
        }
    })
}
export const getAllWrxOptions = (state: RootState) => {
    return state.wrxOptions
}

export default wrxOptionSlice.reducer;

  